import { useContext, useEffect } from "react";
import context from "../../store/context";

// import TendersLayout from "./TendersLayout";
import TendersList from "./TendersList";

const TendersPage = () => {
  const {
    selectedCategory,
    setApiPath,
    setSearchParams,
    getCategories,
    tendersCategoryLists,
    getLanguagesAndRegions,
    tendersRegions,
    tendersLanguage,
    tendersPopularCategories,
    getPopularCategories,
    searchParams,
  } = useContext(context);

  useEffect(() => {
    if (tendersCategoryLists.length === 0) {
      getCategories("");
    }
    if (tendersRegions.length === 0 || tendersLanguage.length === 0) {
      getLanguagesAndRegions("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tendersPopularCategories.length === 0) {
      getPopularCategories("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setApiPath("tender/search");
    setSearchParams({
      ...searchParams,
      // title: "",
      categoryId: selectedCategory,
      // regionId: "",
      // languageId: "",
      // startDate: "",
      // endDate: "",
      // status: "",
      page: "",
      companyId: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setApiPath, setSearchParams]);

  return (
    <TendersList
      filter={""}
      categorySlider={true}
      showSearchSidebar={true}
      noTendersPlaceholder={<div>No result</div>}
    />
  );
};

export default TendersPage;
